<template>
  <div>
    <v-container fluid>

      <div class="main">

        <v-row>
          <v-col cols="12" lg="6">
            <v-tabs background-color="transparent" color="gifty">
              <v-tab to="/account-cards">
                <v-icon left size="20">mdi-account-group</v-icon>
                Liste des utilisateurs
              </v-tab>

              <v-tab to="/account-cards-templates">
                <v-icon left size="20">mdi-card-account-details</v-icon>
                Modèles de carte GIFTY
              </v-tab>
            </v-tabs>

          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-card class="rounded-lg shadow">
              <v-overlay :value="overlay" absolute color="white" opacity="0.5">
                <v-progress-circular
                    color="primary"
                    indeterminate
                    size="50"
                ></v-progress-circular>
              </v-overlay>

              <v-card-title>
                <div>
                  <v-text-field
                      v-model="keyword"
                      append-icon="mdi-magnify"
                      clearable
                      dense
                      filled
                      hide-details
                      placeholder="Rechercher..."
                      rounded
                      single-line

                  />
                </div>
                <v-spacer/>

                <v-btn color="gifty"
                       @click="createTemplate(null)"
                       depressed
                       class="white--text"
                >
                  <v-icon left>mdi-plus</v-icon>
                  Modèle
                </v-btn>

                <v-btn color="grey"
                       text
                       @click="getData">
                  <v-icon left>mdi-refresh</v-icon>
                  Mettre à jour
                </v-btn>

              </v-card-title>

              <v-divider/>

              <v-card-text v-if="isLoading">
                <v-skeleton-loader type="table"/>
              </v-card-text>

              <div v-else>
                <v-card-text class="pa-0">

                  <v-data-table
                      :headers="headers"
                      :items="templates"
                      :search="keyword"
                  >


                    <template v-slot:item.id="{ item }">
                      <span class="font-weight-medium gifty-text">#{{ item.id }}</span>
                    </template>

                    <template v-slot:item.actions="{ item }">
                      <v-btn icon color="gifty" @click="createTemplate(item)">
                        <v-icon>mdi-pencil-outline</v-icon>
                      </v-btn>
                      <v-btn icon color="gifty" @click="remove(item.id)" disabled>
                        <v-icon>mdi-delete-outline</v-icon>
                      </v-btn>
                    </template>


                    <template v-slot:item.background_color="{ item }">
                      <div class="bg-light rounded-lg pa-2 my-2">
                        <v-icon
                            :color="item.background_color"
                        > mdi-circle
                        </v-icon>
                        {{ item.background_color }}
                      </div>
                    </template>

                    <template v-slot:item.text_color="{ item }">
                      <div class="bg-light rounded-lg pa-2 my-2">
                        <v-icon
                            :color="item.text_color"
                        > mdi-circle
                        </v-icon>
                        {{ item.text_color }}
                      </div>
                    </template>

                    <template v-slot:item.background_image="{ item }">
                      <v-img width="40"
                             class="py-2"
                             contain
                             v-if="item.background_image"
                             :src="fileUrl + item.background_image"
                      />
                      <span v-else>-</span>
                    </template>

                    <template v-slot:item.image="{ item }">
                      <v-img width="40"
                             class="py-2"
                             contain
                             v-if="item.image"
                             :src="fileUrl + item.image"
                      />
                      <span v-else>-</span>
                    </template>

                  </v-data-table>

                </v-card-text>

              </div>
            </v-card>
          </v-col>
        </v-row>

      </div>

      <v-dialog v-model="dialog" width="800" scrollable persistent>
        <v-card>
          <v-card-title>
            {{ titleDialog }}
            <v-spacer/>
            <v-icon @click="dialog = false">mdi-close</v-icon>
          </v-card-title>

          <v-divider/>

          <v-card-text class="pa-8">

            <v-text-field v-model="form.title"
                          :error-messages="errors.title"
                          outlined
                          background-color="grey lighten-5"
                          label="Titre *"/>

            <v-row>
              <v-col cols="12">
                <v-autocomplete v-model="form.service_ids"
                                :error-messages="errors.service_ids"
                                class="c"
                                hide-details="auto"
                                multiple
                                chips
                                deletable-chips
                                small-chips
                                :items="services"
                                item-text="name"
                                item-value="id"
                                outlined
                                dense
                                label="Services *"/>
              </v-col>
              <v-col cols="12">

                <v-autocomplete v-model="form.fee_ids"
                                :error-messages="errors.fee_ids"
                                class="c"
                                hide-details="auto"
                                multiple
                                chips
                                deletable-chips
                                small-chips
                                :items="fees"
                                item-text="name"
                                item-value="id"
                                outlined
                                dense
                                label="Frais"/>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="form.name"
                              :error-messages="errors.name"
                              dense
                              outlined
                              hide-details="auto"
                              label="Nom fr *"/>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="form.name_ar"
                              :error-messages="errors.name_ar"
                              dense
                              outlined
                              hide-details="auto"
                              label="Nom ar *"/>
              </v-col>
              <v-col cols="6">
                <v-textarea v-model="form.description"
                            rows="2"
                            :error-messages="errors.description"
                            dense
                            outlined
                            hide-details="auto"
                            label="Description fr"/>
              </v-col>
              <v-col cols="6">
                <v-textarea v-model="form.description_ar"
                            rows="2"
                            :error-messages="errors.description_ar"
                            dense
                            outlined
                            hide-details="auto"
                            label="Description ar"/>
              </v-col>

              <v-col cols="6">
                <v-file-input :error-messages="errors.image"
                              ref="image"
                              @change="uploadFile('image',$event)"
                              show-size
                              counter
                              clearable
                              accept="image/*"
                              dense
                              outlined
                              hide-details="auto"
                              label="Image"
                />

              </v-col>
              <v-col cols="6">
                <v-file-input :error-messages="errors.background_image"
                              @change="uploadFile('background_image',$event)"
                              ref="background_image"
                              show-size
                              counter
                              clearable
                              accept="image/*"
                              dense
                              outlined
                              hide-details="auto"
                              label="Image de fond"/>
              </v-col>

              <v-col cols="12" md="6">
                <div class="d-flex align-center">
                  <v-text-field hide-details="auto"
                                v-model="form.background_color"
                                label="Couleur du fond"
                                :error-messages="errors.background_color"
                                placeholder="#FFFFFF"
                                outlined
                                dense
                  >
                  </v-text-field>
                  <v-menu offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon
                             v-bind="attrs"
                             v-on="on"
                      >
                        <v-icon>mdi-palette</v-icon>
                      </v-btn>
                    </template>
                    <v-color-picker
                        v-model="form.background_color"
                        mode="hexa"
                    />
                  </v-menu>
                </div>
              </v-col>

              <v-col cols="12" md="6">
                <div class="d-flex align-center">
                  <v-text-field hide-details="auto"
                                v-model="form.text_color"
                                label="Couleur du texte"
                                :error-messages="errors.text_color"
                                placeholder="#FFFFFF"
                                outlined
                                dense
                  >
                  </v-text-field>
                  <v-menu offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon
                             v-bind="attrs"
                             v-on="on"
                      >
                        <v-icon>mdi-palette</v-icon>
                      </v-btn>
                    </template>
                    <v-color-picker
                        v-model="form.text_color"
                        mode="hexa"
                    />
                  </v-menu>
                </div>
              </v-col>

            </v-row>


          </v-card-text>
          <v-divider/>

          <v-card-actions>
            <v-spacer/>
            <v-btn :loading="btnLoading"
                   color="gifty"
                   depressed
                   dark
                   @click="save">
              <v-icon left>mdi-content-save</v-icon>
              Enregistrer
            </v-btn>
          </v-card-actions>

        </v-card>
      </v-dialog>

    </v-container>
  </div>
</template>

<script>
import {HTTP} from "@/http-common";

export default {
  components: {},
  data() {
    return {
      id: '',
      fileUrl: process.env.VUE_APP_FILE_URL,
      keyword: '',
      titleDialog: '',
      dialog: false,
      overlay: false,
      btnLoading: false,
      isLoading: false,
      services: [],
      fees: [],
      templates: [],
      headers: [
        {
          text: 'ID',
          value: 'id',
        },
        {
          text: 'Titre',
          value: 'title',
        },
        {
          text: 'Nom',
          value: 'name',
        },
        {
          text: 'Image',
          value: 'image',
        },
        {
          text: 'Image de fond',
          value: 'background_image',
        },
        {
          text: 'Couleur du texte',
          value: 'text_color',
        },
        {
          text: 'Couleur de fond',
          value: 'background_color',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
        },
      ],
      errors: {},
      form: {},
      pickers: {
        background: false,
        text: false
      }
    };
  },
  methods: {
    createTemplate(item = null) {
      this.dialog = true
      this.errors = {}

      this.titleDialog = item ? "Modifier un modèle" : "Ajouter un modèle"

      this.form = {
        id: item ? item.id : null,
        service_ids: item ? item.services?.map(el => el.id) : [],
        fee_ids: item ? item.fees?.map(el => el.id) : [],
        title: item ? item.title : null,
        name: item ? item.name : null,
        name_ar: item ? item.name_ar : null,
        description: item ? item.description : null,
        description_ar: item ? item.description_ar : null,
        image: null,
        background_image: null,
        background_color: item ? item.background_color : '#FFFFFF',
        text_color: item ? item.text_color : '#000000'
      }

      if (this.$refs.image) {
        this.$refs.image.reset();
      }

      if (this.$refs.background_image) {
        this.$refs.background_image.reset();
      }

    },
    uploadFile(field, file) {
      this.form[field] = file;
    },
    save() {
      this.errors = {};
      let url = this.form.id ? '/v1/account-cards/templates/' + this.form.id + '/update' : "/v1/account-cards/templates/store";
      let formData = new FormData();

      formData.append('title', this.form.title ?? "");
      formData.append('name', this.form.name ?? "");
      formData.append('name_ar', this.form.name_ar ?? "");
      formData.append('description', this.form.description ?? "");
      formData.append('description_ar', this.form.description_ar ?? "");
      formData.append('image', this.form.image ?? "");
      formData.append('background_image', this.form.background_image ?? "");
      formData.append('background_color', this.form.background_color ?? "");
      formData.append('text_color', this.form.text_color ?? "");

      this.form.service_ids.forEach((id, index) => {
        formData.append(`service_ids[${index}]`, id)
      })

      this.form.fee_ids.forEach((id, index) => {
        formData.append(`fee_ids[${index}]`, id)
      })

      this.btnLoading = true;

      HTTP.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(() => {
        this.btnLoading = false;
        this.$successMessage = "Ce modèle a été enregistré avec succès.";
        this.dialog = false;
        this.getData()
      }).catch(err => {
        this.btnLoading = false;
        this.errors = err.response.data.errors;
        this.$errorMessage = "Une erreur s'est produite veuillez corriger.";
        console.log(err);
      });
    },
    getData() {
      this.isLoading = true
      HTTP.get('/v1/account-cards/templates').then(res => {
        this.templates = res.data.data
        this.isLoading = false
      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
    remove(id) {
      this.id = id;
      this.$confirm_dialog = true;
    },
    deleteItem() {
      this.overlay = true;
      HTTP.delete("/v1/account-cards/templates/" + this.id + "/delete").then(() => {
        this.overlay = false;
        let i = this.templates.findIndex((el) => el.id === this.id);
        this.$delete(this.templates, i);
        this.id = null;
        this.$successMessage = "Cet élément a été supprimé avec succès.";
      }).catch((err) => {
        this.overlay = false;
        console.log(err);
      });
    },
    getServices() {
      HTTP.get('/v1/fees/services').then(res => {
        this.services = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    getFees() {
      HTTP.get('/v1/fees', {
        params: {
          perPage: 1000
        }
      }).then(res => {
        this.fees = (res.data?.data?.data ?? [])
            .filter(f => f.available_for_account_card)
      }).catch(err => {
        console.log(err)
      })
    },
  },
  created() {
    this.getData();
    this.getServices();
    this.getFees();
  },
  watch: {
    $is_confirm: function (el) {
      if (el) {
        this.deleteItem();
        this.$is_confirm = false;
      }
    }
  }
};
</script>

<style>
.c .v-chip:not(.v-chip--active),
.c .v-chip:not(.v-chip--active) .v-icon {
  background: #d60c56 !important;
  color: white !important;
}
</style>